<script> 
    import { fade, fly }                    from 'svelte/transition';
    import { quintOut }                     from 'svelte/easing';
    
	import { headerTitleHome, linkConheca, mailAtendimento, textTelefone, linkTelefone, textWhatsapp, linkWhatsapp, linkAV, alt } from '../store.js';	

    import Vitrine          from '../components/Vitrine.svelte';
    import Busca            from '../components/Busca.svelte';
    import ListaImoveis     from '../components/ListaImoveis.svelte';
	import Forms 			from "../components/Forms.svelte";

	let vitrines = [
		{
			image: 	        'vitrineApp.jpg',
			imageMobile: 	'vitrineAppM.jpg',
			title: 	        'Aplicativo Controlar, todos os serviços en um único lugar',
			link: 	        '#aplicativo'
		}
    ];    
    
    // Formulário
    let fields = [
        {
            title:  'Nome*:',
            name:   'nome',
            required:   'required'
        },
        {
            title:  'Telefone*:',
            name:   'telefone',
            required: 'required',
            classe: 'mask-telefone',
        },
        {
            title:  'Email*:',
            name:   'email',
            type:   'email',
            required: 'required',
        },
        {
            title:  'Destino:',
            name:   'destino',
            type:   'select',
            selectValues: [
                {
                    title: 'Atendimento',
                    value: $mailAtendimento
                },
            ]
        },
        {
            title:     'Mensagem:',
            name:      'mensagem',
            type:      'textarea',
            rows: 4
        }
	];
	
    const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Mensagem:
{mensagem}

{info}
    `;

    let loading = false;
    function send() {
        loading = true;
    }	    

	// Conteúdo Layout
	let conteudoServicos = [
		{
			icon: 		'<i class="fas fa-3x fa-user-tie"></i>',
			title: 		'Gestão Total',
			text: 		'A administração completa <br> do seu condomínio, cuidamos <br> de tudo para você!',
			textButton: 'Saiba mais',
			link: 		'#contato',
		},
		{
			icon: 		'<i class="fas fa-3x fa-shield-alt"></i>',
			title: 		'Seguros',
			text: 		'Proteção residencial e <br> comercial, conheça nosso <br> portifólio de soluções.',
			textButton: 'Saiba mais',
			link: 		'#contato',
		},
		{
			icon: 		'<i class="fas fa-3x fa-file-check"></i>',
			title: 		'Adequação da Convenção',
			text: 		'Seu condomínio mais ágil e <br> seguro, com revisão técnica <br> de convenção e regimento.',
			textButton: 'Saiba mais',
			link: 		'#contato',
		},
	];

	let conteudoDiferenciais = [
		{
			img: 	'diferenciaisSatisfacao.png',
			title: 	'Satisfação dos Clientes',
			text: 	'Atuamos no mercado de administração de condomínios há 25 anos e possuímos um índice de fidelidade de clientes de 98%, por sabermos que nem todo o condomínio é igual e que o trabalho de uma administradora deve ser adequado ao perfil de cada cliente; e não o contrário como normalmente se vê em prática no mercado.',
		},
		{
			img: 	'diferenciaisTecnologia.png',
			title: 	'Tecnologia e Inovação',
			text: 	'Acreditamos que a tecnologia deva nos servir, razão esta que nos motiva a estar em constante melhoria e buscando sempre a melhor interação possível através de aplicativos e do nosso site, o qual poderá servir de apoio aos moradores, sem deixar de fora do foco os nossos canais de comunicação como o e-mail e o Whatsapp da empresa, tornando assim os atendimentos muito mais dinâmicos, precisos e ágeis.',
		},
		{
			img: 	'diferenciaisAssessoria.png',
			title: 	'Assessoria Jurídica',
			text: 	'Temos a consciência da complexidade constante e dos desafios diários que surgem no dia-a-dia condominial, por isto constamos com advogados que trabalham conosco, de forma que toda a orientação passada pela assessoria aos clientes sempre será previamente discutida de forma ampla pela equipe, tornando, assim, o desenvolvimento de um ambiente saudável para todos.',
		},
		{
			img: 	'diferenciaisAtendimento.png',
			title: 	'Atendimento de Qualidade',
			text: 	'Oferecemos suporte à busca de documentos no seu condomínio, sem necessidade de deslocamento até nossa sede. Se você procura tranquilidade e constante retorno ao delegar a administração do seu condomínio, atendimento sempre disponível e preciso, procure-nos! Teremos o maior prazer em lhe atender e estudar o seu condomínio para lhe ajudar! ',
		},
    ];   

	newFlyBanner.mainURL = 'https://appcontrolarimoveis.com.br';
    newFlyBanner.singleView = false;
    newFlyBanner.load('site'); 
</script>

<svelte:head>
    <title>{$headerTitleHome}</title>
</svelte:head>

<!-- Vitrine -->
<Vitrine vitrineHeight="340px" vitrines={vitrines}/>
<!-- Atendimento -->
<section id="atendimento" class="atendimento">
    <div class="container">
        <div class="box text-center">
            <h1 class="title"><strong>Atendimento exclusivo para condomínios</strong></h1>
            <p class="subtitle color-primary mt-25 mb-30"><strong>Com qualidade, agilidade e competência, desde 1995.</strong></p>
            <a href="#contato" class="btn btn-primary-dark" title="Conheça a Controlar">Conheça <strong>a Controlar</strong></a>
        </div>
    </div>
</section>
<!-- Serviços -->
<section id="servicos" class="servicos">
    <!-- Header -->
    <div class="header-section header-section--primary">
        <div class="container d-lg-flex text-center justify-content-lg-between">			
            <h2 class="title"><strong>Nossos Serviços</strong></h2>
            <a href="#contato" title="Solicite uma Proposta" class="btn btn-secondary mt-10 mt-lg-0">Solicite uma Proposta</a>
        </div>
    </div>
    <!-- Conteúdo -->
    <div class="container">
        <div class="itens grid grid-size--1 grid-size-lg--3 grid-size-sm--2 mt-5 mb-5">
            {#each conteudoServicos as item, i}					
                <div class="item text-center anime-scroll">
                    <span class="icon color-destaque">{@html item.icon}</span>
                    <h2 class="subtitle mt-25 mb-15"><strong>{item.title}</strong></h2>
                    <p class="no-breakline-xs subtitle color-primary">{@html item.text}</p>
                    <a class="btn btn-secondary mt-10" href="{item.link}" target="{item.target}" title="{item.textButton}">{item.textButton}</a>
                </div>
            {/each}
        </div>
    </div>
</section>
<!-- Diferenciais -->
<section id="diferenciais" class="diferenciais">
    <!-- Header -->
    <div class="header-section header-section--secondary">
        <div class="container text-center">			
            <h2 class="title"><strong>Diferenciais ControLar</strong></h2>
        </div>
    </div>
    <!-- Conteúdo -->
    <div class="container">
        {#each conteudoDiferenciais as conteudo}				
            <div class="panel anime-scroll">
                <div class="panel__item panel__item--image">
                    <img src="/images/{conteudo.img}" alt="{conteudo.title} {$alt}"/>				
                </div>
                <div class="panel__item panel__item--content">
                    <h3 class="subtitle mb-10"><strong>{conteudo.title}</strong></h3>
                    <p class="color-primary">{conteudo.text}</p>
                </div>
            </div>
        {/each}
    </div>
</section>	
<!-- Aplicativo -->
<section id="aplicativo" class="aplicativo anime-scroll mt-4">
    <div class="container">
        <div class="panel itens">
            <div class="panel__item">
                <img class="img-fluid" src="/images/imgApp.png" alt="Aplicativo {$alt}"/>
            </div>
            <div class="panel__item text-center panel__item--content">
                <h2 class="title"><strong>Aproveite as vantagens do <br> Aplicativo ControLar</strong></h2>
                <h3 class="color-primary subtitle no-breakline-xs mt-3 mb-3"><strong>2° via de boletos, financeiro, documentos, <br> avisos, reservas e muito mais!</strong></h3>
                <a class="btn btn-primary-dark" href={$linkConheca} target="_blank" title="Conheça o aplicativo ControLar a aproveite as vantagens {$alt}">
                    <strong>Conheça</strong> aqui
                </a>
            </div>
        </div>
    </div>
</section>
<!-- Contato -->
<section id="contato" class="contato mt-4 anime-scroll">
    <div class="container">
        <div class="itens row">
            <div class="item col-12 col-lg-6 pb-4 order-lg-last">
                <h2 class="title text-center"><strong>Entre em Contato</strong></h2>
                <p class="color-primary no-brealine-xs text-center mt-4">
                    Nossa equipe está pronta para lhe auxiliar. <br>
                    Fale conosco pelos telefones, ou utilize o formulário abaixo:
                </p>
                <div class="formulario-inline mt-4">					
                    <Forms fields={fields} message={message} htmlbody={false} boxContato={true} />
                </div>
            </div>
            <div class="item item--mapa col-12 col-lg-6">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.9183973052195!2d-51.195864185035035!3d-30.010499436658726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951979c269ef2395%3A0x8a4b3bbabb44a77d!2sControLar%20Gest%C3%A3o%20Imobili%C3%A1ria!5e0!3m2!1spt-BR!2sbr!4v1594143126016!5m2!1spt-BR!2sbr" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" title="Localização"></iframe>
            </div>			
        </div>
    </div>
</section>